import React from "react";
import Grid from "@mui/material/Grid";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import img from "../../assets/imgs/Session-img.png";
import Buttons from "../Button/Button";
import CourseCard from "./CourseCard";
import EmptyCard from "../../components/EmptyCard/EmptyCard";

function InProgress(props) {
  const { courses, setUpdateCart, enrollNowHandler, setOpenSignUpModel } =
    props;

  return (
    <div>
      <Grid container spacing={3}>
        {courses ? (
          <CourseCard
            courses={courses}
            setUpdateCart={setUpdateCart}
            cardBtn="show"
            enrollNowHandler={enrollNowHandler}
            setOpenSignUpModel={setOpenSignUpModel}
          />
        ) : (
          <Grid item xs={12} sm={12} md={12}>
            <EmptyCard
              title="You will find in-progress courses here"
              description="Please stay tuned for new courses"
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default InProgress;
